import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../../../../../../shared/shared.module';
import { BoatyardModule } from '../../../../boatyard.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { ProductsCharterDurationComponent } from './products-charter-duration/products-charter-duration.component';
import { ProductOfferingFormComponent } from './product-offering-form.component';
import { DaySelectionComponent } from './day-selection/day-selection.component';
import { CustomTimeSelectionsComponent } from './custom-time-selections/custom-time-selections.component';
import { ProductDiscountComponent } from './product-discount/product-discount.component';
import { OfferingStartTimesComponent } from './offering-start-times/offering-start-times.component';
import { ProductNameComponent } from './product-name/product-name.component';
import { HoursBetweenComponent } from './hours-between/hours-between.component';

@NgModule({
  declarations: [
    ProductsCharterDurationComponent,
    ProductOfferingFormComponent,
    DaySelectionComponent,
    ProductsCharterDurationComponent,
    CustomTimeSelectionsComponent,
    ProductDiscountComponent,
    OfferingStartTimesComponent,
    ProductNameComponent,
    HoursBetweenComponent,
  ],
  exports: [ProductOfferingFormComponent],
  entryComponents: [ProductOfferingFormComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatRadioModule,
    MatStepperModule,
    FormsModule,
    SharedModule,
    BoatyardModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
  ],
})
export class ProductOfferingFormModule {}
